//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UploadIcon, XCircleIcon } from 'vue-feather-icons'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import ValidationMessages from '~/components/form/ValidationMessages'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'FileUploader',
  components: {
    ValidationMessages,
    UploadIcon,
    XCircleIcon
  },
  mixins: [AxiosErrorHandler],
  props: {
    name: {
      type: String,
      default: 'file'
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'public'
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    validation: {
      type: Object,
      default: null
    },
    allowedFormats: {
      type: Array,
      default () {
        return [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'text/plain'
        ]
      }
    }
  },
  data () {
    return {
      fileUrl: null,
      fileName: null,
      maxSize: process.env.VUE_APP_FILESIZE_LIMIT, // 1MB
      error: null,
      uploading: false
    }
  },
  watch: {
    value (n) {
      if (n && n.fileName && !this.fileName) {
        this.fileName = n.fileName
      }
    }
  },
  mounted () {
    if (this.value && this.value.fileName && !this.fileName) {
      this.fileName = this.value.fileName
    }
  },
  methods: {
    selectFile (e) {
      e.preventDefault()
      this.$refs.file.click()
    },
    onFileChange (files) {
      const file = files[0]
      this.uploadFile(file)
    },
    onDragDrop (e) {
      const file = e.dataTransfer.files[0]
      this.uploadFile(file)
    },

    async uploadFile (file) {
      try {
        const { maxSize } = this

        this.error = null
        this.uploading = true

        if (file) {
          const size = file.size / maxSize / maxSize
          const mimeType = file.type
          if (!this.allowedFormats.includes(mimeType)) {
            this.error = this.$t('validation.wrongFormat')
            this.uploading = false
          } else if (size > 1) {
            // check whether the size is greater than the size limit
            this.error = this.$t('validation.too_big')
            this.uploading = false
          } else {
            this.fileUrl = URL.createObjectURL(file)

            // Append file into FormData
            const formData = new FormData()
            formData.append('type', this.type)
            formData.append(this.name, file)

            // submit file to api
            const response = await this.$axios.post('/files', formData, {
              headers: { 'content-type': 'multipart/form-data' }
            })

            // Emit response as file entry
            this.$emit('input', response.data.data)

            this.fileName = response.data.data.fileName

            this.uploading = false
          }
        }
      } catch (err) {
        await this.handleError(err)
      }
    },

    /**
     * TODO add file removal function
     * @param e
     */
    removeFile (e) {
      e.preventDefault()
      this.$emit('remove', this.value)
      this.fileName = null
    }
  }
}
